import { register } from 'swiper/element/bundle'

register() // викликаємо тільки 1 раз навіть якщо свайперов декілька. Взято з документації.

const DEFAULT_CONFIG = {
	slidesPerView: 1,
	loop: true,
	spaceBetween: '40',
}

export const initSwiper = (swiperElement, customConfig = {}) => {
	if (!swiperElement) return

	const swiperParams = {
		...DEFAULT_CONFIG,
		...customConfig,
	}

	Object.assign(swiperElement, swiperParams)
	swiperElement.initialize()
}
